import { useCallback, useRef } from 'react';

export const useOtpApi = () => {
	const otpRef = useRef<{ reset: () => void; focusFirst: () => void }>(null);

	const resetOtpInputValues = useCallback(() => {
		otpRef.current?.reset();
		otpRef.current?.focusFirst();
	}, []);

	return {
		resetOtpInputValues,
		otpRef,
	};
};
